export default __webpack_public_path__ + "img/appointment-cancel.bee38917.svg";